
<div class="content-wrapper">
    <div class="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"> New Manpower Request</h4>
            <h5> Requesters Details</h5>
            <br>
            <form class="forms-sample" #ngNewManPowerForm="ngForm" name="form"
               (ngSubmit)="ngNewManPowerForm.form.valid">    
           
               <div style="background: #ECECEC;padding:30px;">
                <div class="row">
                  <div class="col">
                    <div style="background: white;padding:5px;" class="form-group">
                    <h5>Requester Name</h5> 
                     
                      <p>{{ contract?.requesterName }}</p>
                    </div>
                  </div>
      
                  <!-- Designation -->
                  <div class="col">
                    <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                      <label for="exampleInputCity1">Designation</label>
                      <p>{{ contract?.requesterDesignation }}</p>
                    </div>
                  </div>
  
                    <!-- Function  -->
                    <div class="col">
                      <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                        <label for="selectedfunction">Function</label>
                        <p>{{ contract?.requesterFunction }}</p>
                        
                      </div>
                    </div>
              </div>
                  <div class="row">

                  <!-- Unit  -->
                  <div class="col">
                    <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                      <label for="selectedfunction">Unit</label>
                      <p>{{ contract?.requesterUnit }}</p>
                    </div>
                  </div>

                 <!-- Request Date  -->
                  <div class="col">
                    <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                      <label for="exampleInputCity1">Request Date</label>
                      <p>{{ contract?.requestDate | date: 'dd/MM/yyyy'}}</p>
                    </div>
                  </div>
                   
                 
                </div>
              </div>
             
              <br>
  
  
              <h5>Details Of Required Manpower</h5>
              <br>
             
  
  
           <div style="background: #ECECEC;padding:30px;">
            <div class="row">
  
              <!-- Job Title -->
     
              <div class="col">
                <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                  <label for="description">Job Title</label>
                  <p>{{ contract?.jobTitle }}</p>
                </div>
              </div>
  
              <!-- N+1 Designation  -->
              <div class="col">
                <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                  <label for="description">N + 1 Designation</label>
                  <p>{{ contract?.nPlus1Designation }}</p>
  
                </div>
              </div>
  
                <!-- Band  -->
                <!-- <div class="col">
                  <div class="form-group">
                    <label for="description">Band</label>
                    <input type="text" class="form-control" id="Band"  [(ngModel)]="Band"
                      placeholder="Band" name="Band"  #band="ngModel"  required
                      >
                      <div class="alert alert-danger" role="alert"
                      *ngIf="ngNewManPowerForm.submitted && band.errors">
                      Band is required!
                    </div>
                  </div>
                </div> -->
                <div class="col">
                  <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                    <label for="costCenter">Band</label>
                    <p>{{ contract?.band }}</p>
                  </div>
                </div>
  
                 
            </div>
            <div class="row">
              <!-- Cost Center  -->
   <div class="col">
       <div style="background: white;padding:5px; justify-content: center;" class="form-group">
         <label for="costCenter">Cost Center</label>
         <p>{{ contract?.costCenter }}</p>
       </div>
     </div>
  
      <!-- Location  -->
      <div class="col">
          <div style="background: white;padding:5px; justify-content: center;" class="form-group">
            <label for="selectedLocation">Location</label>
            <p>{{ contract?.location }}</p>
          </div>
        </div>
         </div>
  
         <div class="row">
            <!-- Date Vacancy Occured  -->
            <div class="col">
              <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                <label for="exampleInputCity1">Date Vacancy Occured</label>
                <p>{{ contract?.dateVacancyOccurred | date: 'dd/MM/yyyy'}}</p>
              </div>
            </div>
  
              <!-- Required Number  -->
              <div class="col">
                  <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                    <label for="description">Required Number</label>
                    <p>{{ contract?.requiredNumber }}</p>
                  </div>
                </div>
         </div>
         <br>
         
         <div class="row">
          <div class="col">
            <div style="background: white;padding:5px; justify-content: center;" class="form-group">
              <label for="TypeOfVacancy">Type Of Vacancy</label>
              <p>{{ contract?.typeOfVacancy }}</p>
            </div>
          </div>
       
         <div class="col">
          <div style="background: white;padding:5px; justify-content: center;" class="form-group">
            <label for="costCenter">Reason For Vacancy</label>
            <p>{{ contract?.reasonForVacancy }}</p>
          </div>
        </div>
      </div>
         <!-- <div class="row">
  
          <label class="col-sm-0 col-form-label"> FTE </label>
          <div class="col-sm-1">
              <div class="form-check">
                <label class="form-check-inline"> 
                     <input type="radio" class="form-check-input" [(ngModel)]="typeOfVacancy" value="FTE" name="typeofvacancy" id="fte">
                </label>
              </div>   
            </div>
  
            <label class="col-sm-0 col-form-label"> FTC: </label>
            <div class="col-sm-1">
                <div class="form-check">
                  <label class="form-check-inline"> 
                       <input type="radio" class="form-check-input" [(ngModel)]="typeOfVacancy" value="FTC" name="typeofvacancy" id="ftc">
                  </label>
                </div>   
              </div>
  
              <label class="col-sm-0 col-form-label"> Consultant: </label>
              <div class="col-sm-1">
                  <div class="form-check">
                    <label class="form-check-inline"> 
                         <input type="radio" class="form-check-input" [(ngModel)]="typeOfVacancy" value="Consultant" name="typeofvacancy" id="consultant">
                    </label>
                  </div>   
                </div>
  
                <label class="col-sm-0 col-form-label"> Internship: </label>
                <div class="col-sm-1">
                    <div class="form-check">
                      <label class="form-check-inline"> 
                           <input type="radio" class="form-check-input" [(ngModel)]="typeOfVacancy" value="Internship" name="typeofvacancy" id="internship">
                      </label>
                    </div>   
                  </div>
            </div> -->
            <br>
            
            <!-- <label> Reason For Vacancy:</label>
            <div class="row">
             <label class="col-sm-0 col-form-label"> Resignation </label>
             <div class="col-sm-1">
                 <div class="form-check">
                   <label class="form-check-inline"> 
                        <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="Resignation" name="reasonforvacancy" id="resignation">
                   </label>
                 </div>   
               </div>
  
               <label class="col-sm-0 col-form-label"> Termination: </label>
               <div class="col-sm-1">
                   <div class="form-check">
                     <label class="form-check-inline"> 
                          <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="Termination" name="reasonforvacancy" id="termination">
                     </label>
                   </div>   
                 </div>
  
                 <label class="col-sm-0 col-form-label"> Dismissal: </label>
                 <div class="col-sm-1">
                     <div class="form-check">
                       <label class="form-check-inline"> 
                            <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="Dismissal" name="reasonforvacancy" id="dismissal">
                       </label>
                     </div>   
                   </div>
  
                   <label class="col-sm-0 col-form-label"> Retirement: </label>
                   <div class="col-sm-1">
                       <div class="form-check">
                         <label class="form-check-inline"> 
                              <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="Retirement" name="reasonforvacancy" id="retirement">
                         </label>
                       </div>   
                     </div>
  
                     <label class="col-sm-0 col-form-label"> New Position: </label>
                     <div class="col-sm-1">
                         <div class="form-check">
                           <label class="form-check-inline"> 
                                <input type="radio" class="form-check-input" [(ngModel)]="reasonForVacancy" value="New Position" name="reasonforvacancy" id="newposition">
                           </label>
                         </div>   
                       </div>
               </div>
         -->
  
         <div class="row">
            <!-- Other Specify  -->
            <div class="col">
              <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                <label for="description">OTHER (Specify)</label>
                <p>{{ contract?.requesterComment }}</p>
              </div>
            </div>
            <!-- <div class="col">
              <div class="form-group">
                <label for="document" class="control-label col-md-10">Select Document (Job Description)</label>
                <div class="col-md-10">
                  <input type="file" (change)="onFileChange($event)" placeholder="Upload file" [(ngModel)]="file"
                    accept=".pdf,.doc" #fileInput name="fileInput" style="padding-top:2px;"
                    class="form-control">
                </div>
              </div>
            </div> -->
  
          </div>
          <div class="row">
            <!-- <div class="col">
              <div class="form-group">
                <label for="document" class="control-label col-md-10">Select Document (Job Description)</label>
                <div class="col-md-10">
                  <input type="file" (change)="onFileChange($event)" placeholder="Upload file" [(ngModel)]="file"
                    accept=".pdf,.doc" #fileInput name="fileInput" style="padding-top:2px;"
                    class="form-control">
                </div>
              </div>
            </div> -->
  
            <!-- <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">Document Description</label>
                <input type="text" class="form-control" id="docdescription" placeholder="ex: describe the document" [(ngModel)]="documentDescription"
                name="docdescription" required>
              
              </div>
            </div> -->
          </div>
    
         </div>
           <br>
           <h5> Mode Of Recruitment</h5>
           <br>
            
            <div style="background: #ECECEC;padding:30px;">
              <div class="row">
                <div style="background: white;padding:5px; justify-content: center;" class="col">
                  <div class="form-group">
                    <label for="exampleSelectDesignation">Mode Of Recruitment</label>
                    <p>{{ contract?.modeOfRecruitment }}</p>
                  </div>
                </div>
            </div>
                <!-- <label class="col-sm-1 col-form-label"> FTE </label> -->
                <!-- <div class="col-sm-1">
                    <div class="form-check">
                      <label class="form-check-inline"> 
                           <input type="radio" class="form-check-input"  [(ngModel)]="modeOfRecruitment" value="FTE" name="modeofrecruitment" id="fte">
                      </label>
                    </div>   
                  </div> -->
    
                  
                    <!-- <div class="row" *ngIf="isreasonForVacancyVisible">
                      <label class="col-sm-3 col-form-label"> Internal Movement </label> 
                      <div class="col-sm-3">
                          <div class="form-check">
                            <label class="form-check-inline"> 
                                 <input type="checkbox" class="form-check-input"   [(ngModel)]="FTERequirements.InternalMovement" name="modeofrecruitmentfte" id="internalmovement">
                            </label>
                          </div>   
                        </div>
                        <label class="col-sm-3 col-form-label"> External(New Staff) </label> 
                       
                        <div class="col-sm-1">
                            <div class="form-check">
                              <label class="form-check-inline"> 
                                   <input type="checkbox" class="form-check-input" [(ngModel)]="FTERequirements.ExternalNewStaff" name="modeofrecruitmentfte" id="externalnewstaff">
                              </label>
                            </div>   
                          </div>
                    </div> -->
                 
                    <!-- <label class="col-sm-1 col-form-label"> FTC </label>
                    <div class="col-sm-1">
                        <div class="form-check">
                          <label class="form-check-inline"> 
                               <input type="radio" class="form-check-input"  [(ngModel)]="modeOfRecruitment" value="FTC" name="modeofrecruitment" id="ftc">
                          </label>
                        </div>   
                      </div> -->
    
                        <!-- Duration of contract  -->
                        <!-- <div class="col">
                          <div class="form-group">
                            <label for="description">Contract Duration (Month)</label>
                            <input type="number" class="form-control" id="durationofcontract"
                              placeholder="Duration Of Contract"  name="durationofcontract" [(ngModel)]="ftcdurationofcontract"
                              >
                          </div>
                        </div>
    
                         Estimated Annual Cost  
                      <div class="col">
                        <div class="form-group">
                          <label for="description">Estimated Annual Cost</label>
                          <input type="number" class="form-control" id="estimatedcost"
                            placeholder="Estimated Annual Cost " name="estimatedcost" [(ngModel)]="ftcestimatedcost"
                            >
                        </div>
                      </div> -->
                
                    <!-- <label class="col-sm-0 col-form-label"> Consultant: </label>
                    <div class="col-sm-1">
                        <div class="form-check">
                          <label class="form-check-inline"> 
                               <input type="radio" class="form-check-input" value="Consultant"  [(ngModel)]="modeOfRecruitment" name="modeofrecruitment" id="consultant">
                          </label>
                        </div>   
                      </div>
     -->
                        <!-- Duration of contract  -->
                        <div class="row">
                        <div class="col">
                          <div style="background: white;padding:5px; justify-content: center;" class="form-group">   
                            <label for="description">Contract Duration (Month)</label>
                            <p>{{ contract?.durationOfContract }}</p>
                          </div>
                        </div>
    
                          <!-- Estimated Annual Cost  -->
                      <div class="col">
                        <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                          <label for="description">Estimated Annual Cost</label>
                          <p>{{ contract?.estimatedAnnualCost }}</p>
                        </div>
                      </div>
                  </div>
    
                
                  </div>
                  <div class="col">
                    <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                      <label for="exampleTextarea1">Justification For Vacancy</label>
                      <p>{{ contract?.justificationForVacancy }}</p>
                    </div>
                  </div>
                  <div class="row">
    
                  </div>
            
      
  
              <br>
             
              <h5>Role Requirements</h5>
              <br>
  
  
              <div style="background: #ECECEC;padding:30px;">
                <div class="row">
               
    
                  <!-- Educational Qualification  -->
                  <div class="col">
                    <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                      <label for="justification">Educational Qualification</label>
                      <p>{{ contract?.qualification }}</p>
                    </div>
                  </div>
      
                  <!-- Skills Required  -->
                  <div class="col">
                    <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                      <label for="justification">Skills Required</label>
                      <p>{{ contract?.skillsRequired }}</p>
                    </div>
                  </div>
  
                   <!-- Experience  -->
                   <div class="col">
                    <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                      <label for="exampleTextarea1">Experience</label>
                      <p>{{ contract?.experience }}</p>
                    </div>
                  </div>
                </div>
  
               
        
                <label> Systems Requirements</label>
                      <div class="row">
                        <p>{{ contract?.systemRequired }}</p>
                      </div>
                   
                      <div class="row">
                        <!-- Other Requirements  -->
                        <div class="col">
                          <div style="background: white;padding:5px; justify-content: center;" class="form-group">
                            <label for="description">Other Requirement</label>
                            <p>{{ contract?.otherSystemRequirements }}</p>
                          </div>
                        </div>
                  </div>

                  <div class="row" *ngIf="ViewlevelOfCompliance">
                    <div style="background: white;padding:5px;"class="col">
                      <label><b>Approved Budget For The Department</b></label>
                      <p>{{ contract?.presentDepartmentManpowerFigure }}</p>
                    </div>
                    <div style="background: white;padding:5px;" class="col">
                      
                      <label><b>Present Manpower Figure For The Department</b></label>
                      <p>{{ contract?.presentDepartmentManpowerFigure }}</p>
                    </div>
                    <div style="background: white;padding:5px;" class="col">
                      <label><b>Level Of Exposure(Compliance)</b></label>
                      <p>{{ contract?.levelOfExposureCompliance }}</p>
                    </div>
                  </div>
              </div>
    
            <hr>
                  <div class="text-left">
                    <button type="submit" class="btn btn-primary mr-2 ">Submit</button>
                    <button class="btn btn-light">Cancel</button>
                  </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>